module.exports = __webpack_public_path__ + "assets/icon-radiobox-selected.01992459.svg";